
 <article class="project-details-forbidden-features-stages">
  <div class="project-stage project-stage-one" [style.background-color]="project.status.color">
    <div class="project-stage-arrow">
    <div class="project-stage-first">
      <h4 class="ng-binding"> <em>{{project.status.name}}</em> <strong></strong></h4>
      <span class="project-stage-arrow-top"></span>
      <span class="project-stage-arrow-bottom"></span>
    </div>
    </div>
  </div>
  <div class="project-details-forbidden-message">
    <core-helpers-box-alert-message-icon
      [text]="'You don’t have permission to see this project'"
      [icon]="'alert'"
    ></core-helpers-box-alert-message-icon>
  </div>
</article>

  <!-- PROJECT details features-->
<article class="project-details-forbidden-features">
  <div class="project-details-forbidden-features-main">
    <div class="project-details-forbidden-features-content-avatars">
      <!-- PROJECT OWNER AND ASIGNEE -->
      <div class="project-details-forbidden-features-owner">
        <!-- TODO: owner not in the headers data by now -->
        <core-helper-box-header-user-date
        [date]="project.date_created"
        [user]="project.user_owner"
        [preText]="'<strong>Created by</strong>'"
        ></core-helper-box-header-user-date>
      </div>
      <!-- CONTROL ASIGNEE is set!!!-->
      <div class="project-details-forbidden-features-asignee">
        <core-helper-box-header-user-assignee
          [user]="project.user_assigned"
          [interactive]="interactiveAsignee"
          [users]="[]"
          [preText]="'<strong>Assigned to</strong>'"
        ></core-helper-box-header-user-assignee>
        <!-- delay-clock green-clock red-clock -->
        <div class="project-details-forbidden-features-duedate" >
          <!-- will be allways calendar icon 15/2/2022 -->
          <core-helpers-forms-button-icon [text]="project.due_date | date:'dd MMM yyyy'" [icon]="due.icon"></core-helpers-forms-button-icon>
        </div>
      </div>
    </div>
  </div>

</article>
  <!-- End PROJECT details features -->
